import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { TypeService } from '../../../../../services/type/type-service';
import { map, startWith } from 'rxjs/operators';
import { Subscribable } from '../../../../../models/base/subscribable';
import { Subscription } from 'rxjs';
import { VbWithdrawalStepFormGroup } from '../../../forms/vb-withdrawal-step-form-group';
import { ButtonTypeEnum } from '../../../../../ui/buttons/button/button-type.enum';

@Component({
  selector: 'app-vb-withdrawal-instructions-card',
  templateUrl: './vb-withdrawal-instructions-card.component.html',
  styleUrls: ['./vb-withdrawal-instructions-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VbWithdrawalInstructionsCardComponent extends Subscribable implements OnChanges {
  @Input() formGroup!: VbWithdrawalStepFormGroup;
  @Input() formSubmitted: boolean = false;

  @Output() valuesCleared: EventEmitter<void> = new EventEmitter();

  private typeService = inject(TypeService);
  public fundTypes$ = this.typeService.fundTypes$.pipe(map(types => types.filter(type => !type.isCash())));

  public percentageTotal = '0.00';

  private percentageSubscription?: Subscription;

  private listenToPercentageChanges(): void {
    this.percentageSubscription?.unsubscribe();

    this.percentageSubscription = this.formGroup.controls.instructions.valueChanges
      .pipe(startWith(this.formGroup.controls.instructions.getRawValue()))
      .subscribeWhileAlive({
        owner: this,
        next: () => {
          const rawValues = this.formGroup.controls.instructions.getRawValue();
          const percentages = rawValues.map(instruction => instruction.percentage);
          this.percentageTotal = this.calculatePercentageTotal(percentages);
        }
      });
  }

  private calculatePercentageTotal(percentages: (number | null | undefined)[]): string {
    const total: number = percentages.reduce<number>((sum, val) => {
      const percentage = val ?? 0;
      return sum + (percentage > 0 ? percentage : 0);
    }, 0);
    return total.toFixed(2);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.formGroup && !!this.formGroup) {
      this.listenToPercentageChanges();
    }
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
